import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { MdSearchOff, MdCategory, MdSearch } from "react-icons/md";

import styles from "./Category.module.scss";
import { useCategory } from "./useCategory";
import { useSearch } from "../../common/components/search/useSearch";
import { Search } from "../../common/components/search/Search";
import { PageHeader } from "../../common/components/pageHeader/PageHeader";
import { EmptyState } from "../../common/components/emptyState/EmptyState";
import { categoryRoute } from "../../common/utils/constants";

export const Category: React.FC = () => {
  const { query, setQuery, clearSearch, isDebouncing } = useSearch(400, true);
  const { items, total, ready, isFetching, isFetchingMore, lastItemRef } =
    useCategory();

  if (!ready) return null;

  const isBusy = isFetching || isDebouncing;

  return (
    <div className={styles.Page}>
      <Helmet>
        <title>Категории — ЛОГМОЛЛ</title>
      </Helmet>

      <PageHeader title="Категории" subtitle={`${total} категорий`} />

      <div className={styles.SearchWrap}>
        <Search
          value={query}
          onChange={setQuery}
          clear={clearSearch}
          placeHolder="Поиск по названию категории..."
        />
      </div>

      {items.length === 0 && !isBusy ? (
        query.trim() ? (
          <EmptyState
            icon={MdSearchOff}
            title="Ничего не найдено"
            description={`По запросу «${query}» нет категорий.`}
          />
        ) : (
          <EmptyState
            icon={MdSearch}
            title="Введите запрос"
            description="Начните вводить название категории, чтобы найти нужное."
          />
        )
      ) : items.length === 0 && isBusy ? (
        <div style={{ minHeight: 400 }} />
      ) : (
        <>
          <div className={styles.Grid}>
            {items.map((c, index) => {
              const isLast = index === items.length - 1;

              return (
                <Link
                  key={c.id}
                  to={categoryRoute(c.id!)}
                  className={styles.Card}
                  ref={isLast ? lastItemRef : undefined}
                >
                  <span className={styles.BgName} aria-hidden="true">
                    {c.name}
                  </span>
                  <h3 className={styles.Name}>{c.name}</h3>
                  {c.description && (
                    <p className={styles.Description}>{c.description}</p>
                  )}
                </Link>
              );
            })}
          </div>

          {isFetchingMore && (
            <div
              style={{
                textAlign: "center",
                padding: "20px",
                color: "var(--text-secondary)",
              }}
            >
              Загрузка...
            </div>
          )}
        </>
      )}
    </div>
  );
};